import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../lib/auth";

export default function Signup() {
  const { signup } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/";
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signup(form);
      toast.success("Welcome to BalloonBites!");
      nav(next);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <Navbar />
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-16 px-6 py-20 lg:grid-cols-2 lg:px-10" data-testid="signup-page">
        <div className="hidden lg:block">
          <p className="label-tiny mb-3">Join us</p>
          <h1 className="font-serif text-5xl leading-tight text-[#2a2928]">
            Create an account to <span className="italic text-[#d08c8c]">start gifting.</span>
          </h1>
          <p className="mt-6 max-w-md text-[#7a7571]">
            Save recipients, track hampers, and unlock member-only surprises.
          </p>
        </div>

        <form onSubmit={submit} className="rounded-3xl border border-[#e8e2da] bg-white p-10">
          <h2 className="font-serif text-3xl">Create account</h2>
          <div className="mt-6 space-y-4">
            <div>
              <Label htmlFor="name">Full name</Label>
              <Input id="name" data-testid="signup-name" value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-2 rounded-xl" required />
            </div>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" data-testid="signup-email" value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-2 rounded-xl" required />
            </div>
            <div>
              <Label htmlFor="phone">Phone</Label>
              <Input id="phone" data-testid="signup-phone" value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })} className="mt-2 rounded-xl" required />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" data-testid="signup-password" value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-2 rounded-xl" required minLength={6} />
            </div>
          </div>
          <Button
            type="submit"
            data-testid="signup-submit"
            disabled={loading}
            className="mt-6 w-full rounded-full bg-[#d08c8c] py-6 text-white hover:bg-[#b87a7a]"
          >
            {loading ? "Creating..." : "Create account"}
          </Button>
          <p className="mt-6 text-center text-sm text-[#7a7571]">
            Already have an account?{" "}
            <Link to={`/login?next=${encodeURIComponent(next)}`} data-testid="signup-to-login" className="font-medium text-[#d08c8c] hover:underline">
              Sign in
            </Link>
          </p>
        </form>
      </div>
      <Footer />
    </div>
  );
}
